import { FigmaComponentBooleanProperty, FigmaComponentInstanceSwapProperty, FigmaComponentOrigin, FigmaComponentProperty, FigmaComponentTextProperty, FigmaComponentVariantProperty, ObjectMeta, } from "@supernova-studio/model";
import { z } from "zod";
const DTOFigmaComponentBooleanProperty = FigmaComponentBooleanProperty;
const DTOFigmaComponentInstanceSwapProperty = FigmaComponentInstanceSwapProperty;
const DTOFigmaComponentTextProperty = FigmaComponentTextProperty;
const DTOFigmaComponentVariantProperty = FigmaComponentVariantProperty;
const DTOFigmaComponentProperty = FigmaComponentProperty;
const DTOFigmaComponentPropertyMap = z.record(DTOFigmaComponentProperty);
export const DTOFigmaComponent = z.object({
    id: z.string(),
    persistentId: z.string(),
    designSystemVersionId: z.string(),
    brandId: z.string(),
    thumbnailUrl: z.string().optional(),
    svgUrl: z.string().optional(),
    exportProperties: z.object({
        isAsset: z.boolean(),
    }),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    meta: ObjectMeta,
    originComponent: FigmaComponentOrigin.optional(),
    parentComponentPersistentId: z.string().optional(),
    childrenPersistentIds: z.string().array().optional(),
    componentPropertyDefinitions: DTOFigmaComponentPropertyMap.optional(),
    variantPropertyValues: z.record(z.string()).optional(),
});
export const DTOFigmaComponentListResponse = z.object({
    components: DTOFigmaComponent.array(),
});
